/**
 * Asset Tooltip
 * Shows on hover over map assets/areas with smart positioning.
 */

import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { useAppSelector } from '../../store/hooks';
import { colorPalette } from '../../theme';

const MARGIN = 12;

const AssetTooltip = () => {
  const tooltip = useAppSelector((state) => state.map.tooltip);

  if (!tooltip) return null;

  // Simple positioning: offset from cursor, clamped later by CSS if needed
  const style = {
    position: 'absolute',
    left: tooltip.x + MARGIN,
    top: tooltip.y + MARGIN,
    pointerEvents: 'none',
    zIndex: 1000,
    maxWidth: 280,
  };

  if (tooltip.type === 'asset') {
    return (
      <Paper elevation={4} sx={style}>
        <Box sx={{ px: 2, py: 1 }}>
          {tooltip.unitNumber && (
            <Typography variant="subtitle2" fontWeight={700}>
              {tooltip.unitNumber}
            </Typography>
          )}
          {tooltip.lastReceived && (
            <Typography variant="caption" color="text.secondary" display="block">
              Last Received: {tooltip.lastReceived}
            </Typography>
          )}
          <Box sx={{ display: 'flex', gap: 1, mt: 1, alignItems: 'center' }}>
            {tooltip.typeName && (
              <Typography variant="caption" sx={{ color: colorPalette.asseTracOrange }}>
                {tooltip.typeName}
              </Typography>
            )}
            {tooltip.subTypeName && (
              <Typography variant="caption" color="text.secondary">
                {tooltip.subTypeName}
              </Typography>
            )}
            {tooltip.cleanStatus === 'dirty' && (
              <Typography variant="caption" sx={{ color: '#CF3028', fontWeight: 700 }}>
                DIRTY
              </Typography>
            )}
          </Box>
        </Box>
      </Paper>
    );
  }

  if (tooltip.type === 'area') {
    return (
      <Paper elevation={4} sx={style}>
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="subtitle2" fontWeight={700}>
            {tooltip.name || 'Area'}
          </Typography>
          {tooltip.areaType && (
            <Typography variant="caption" color="text.secondary">
              {tooltip.areaType}
            </Typography>
          )}
        </Box>
      </Paper>
    );
  }

  if (tooltip.type === 'project') {
    return (
      <Paper elevation={4} sx={style}>
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="subtitle2" fontWeight={700}>
            {tooltip.name || 'Project'}
          </Typography>
          {tooltip.client && (
            <Typography variant="caption" color="text.secondary" display="block">
              Client: {tooltip.client}
            </Typography>
          )}
          {tooltip.status && (
            <Typography variant="caption" sx={{ color: colorPalette.asseTracOrange }}>
              Status: {tooltip.status}
            </Typography>
          )}
        </Box>
      </Paper>
    );
  }

  return null;
};

export default AssetTooltip;
